export const MAX_FILE_SIZE_MB = 30;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Valida um arquivo PDF
 */
export const validatePDF = (file) => {
  if (!file) {
    return { isValid: false, error: 'Nenhum arquivo selecionado' };
  }

  const isValidSize = file.size <= MAX_FILE_SIZE_BYTES;
  const isValidType = file.type === 'application/pdf';
  const isValidExtension = file.name.toLowerCase().endsWith('.pdf');

  if (!isValidSize) {
    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
    return {
      isValid: false,
      error: `Arquivo muito grande: ${fileSizeMB}MB. Máximo permitido: ${MAX_FILE_SIZE_MB}MB`
    };
  }

  if (!isValidType || !isValidExtension) {
    return {
      isValid: false,
      error: 'Apenas arquivos PDF são permitidos'
    };
  }

  return { isValid: true, error: null };
};

/**
 * Valida o tamanho somado de todos os arquivos de um pedido/protocolo — a API
 * de Anexo de GEDs limita 30MB na soma de todos os arquivos da requisição,
 * não por arquivo individual.
 */
export const validateTotalSize = (files) => {
  const totalBytes = (files || []).filter(Boolean).reduce((sum, file) => sum + file.size, 0);

  if (totalBytes > MAX_FILE_SIZE_BYTES) {
    const totalMB = (totalBytes / (1024 * 1024)).toFixed(2);
    return {
      isValid: false,
      error: `Tamanho total dos arquivos: ${totalMB}MB. Máximo permitido: ${MAX_FILE_SIZE_MB}MB somando todos os documentos deste pedido`
    };
  }

  return { isValid: true, error: null };
};

/**
 * Calcula quantos documentos obrigatórios foram enviados
 */
export const calculateRequiredProgress = (requiredDocs, documentos) => {
  if (requiredDocs.length === 0) return { percent: 100, sent: 0, total: 0 };
  const sent = requiredDocs.filter(doc => documentos[doc.id]).length;
  const percent = (sent / requiredDocs.length) * 100;
  return { percent, sent, total: requiredDocs.length };
};

/**
 * Filtra documentos visíveis (considerando regras condicionais)
 */
export const getVisibleConditionalDocs = (conditionalDocs, formData, shouldShowFn) => {
  return conditionalDocs.filter(doc => shouldShowFn(doc, formData));
};
